export default element => {

    var maxItems = element.hasAttribute('data-loadmore-max') ? parseInt(element.getAttribute('data-loadmore-max')) : 10;
    var useLessButton = (element.hasAttribute('data-loadmore-less') && element.getAttribute('data-loadmore-less') == "true") ? true : false;
    var items = Array.prototype.slice.call(element.querySelectorAll("[data-loadmore-content]"));
    var moreBtn = element.querySelector("[data-loadmore-button]");
    var hiddenClass = 'd-none';
    var visibleCount = maxItems;

    var update = function () {
        var index = 0;

        if (moreBtn.hasAttribute('data-less'))
            visibleCount = maxItems;

        items.forEach(function (item) {
            if (item.hasAttribute("data-loadmore-skip"))
                return;

            if (index < visibleCount)
                item.classList.remove(hiddenClass);
            else
                item.classList.add(hiddenClass);

            index++;
        });

        if (!useLessButton) {
            if (index <= visibleCount)
                moreBtn.classList.add(hiddenClass);
            else
                moreBtn.classList.remove(hiddenClass);
        } else {
            if (index <= maxItems)
                moreBtn.classList.add(hiddenClass);

            if (index <= visibleCount) {
                moreBtn.setAttribute('data-less', '');
                moreBtn.querySelector('a').innerHTML = moreBtn.querySelector('a').getAttribute('data-less-text');
            } else {
                moreBtn.removeAttribute('data-less', '');
                moreBtn.querySelector('a').innerHTML = moreBtn.querySelector('a').getAttribute('data-loadmore-text');
            }
        }

        document.autoimage.handle();
    };
    element.addEventListener("update", update);

    moreBtn.addEventListener('click', function () {
        visibleCount += (useLessButton) ? 99999 : maxItems;
        update();
    });

    update();
}